// extracted by mini-css-extract-plugin
export default {"results":"SearchResults_results__AWRZX","resultItem":"SearchResults_resultItem__a3Xw0","container":"SearchResults_container__J3Qqr"};